import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// SUPER_ADMIN "View As" mode: scope every request to the selected customer tenant
api.interceptors.request.use((config) => {
  const vt = sessionStorage.getItem("view_tenant");
  if (vt) config.params = { ...(config.params || {}), view_tenant: vt };
  return config;
});

export const MGR_ROLES = ["SUPER_ADMIN", "TENANT_ADMIN", "HR_ADMIN", "HR_MANAGER", "PAYROLL_ADMIN", "PAYROLL_APPROVER", "FINANCE", "DEPARTMENT_HEAD", "MANAGER", "SUPERVISOR", "AUDITOR"];
export const PAYROLL_ROLES = ["SUPER_ADMIN", "TENANT_ADMIN", "PAYROLL_ADMIN", "PAYROLL_APPROVER", "FINANCE"];
export const HR_ROLES = ["SUPER_ADMIN", "TENANT_ADMIN", "HR_ADMIN", "HR_MANAGER"];

export const STATUS_COLORS = {
  PENDING: "bg-amber-50 text-amber-700 border-amber-200",
  APPROVED: "bg-emerald-50 text-emerald-700 border-emerald-200",
  REJECTED: "bg-rose-50 text-rose-700 border-rose-200",
  OPEN: "bg-slate-100 text-slate-700 border-slate-200",
  CALCULATED: "bg-blue-50 text-blue-700 border-blue-200",
  VALIDATED: "bg-cyan-50 text-cyan-700 border-cyan-200",
  LOCKED: "bg-slate-800 text-white border-slate-800",
  PRESENT: "bg-emerald-50 text-emerald-700 border-emerald-200",
  LATE: "bg-amber-50 text-amber-700 border-amber-200",
  CONFIRMED: "bg-emerald-50 text-emerald-700 border-emerald-200",
  PROBATION: "bg-amber-50 text-amber-700 border-amber-200",
  CONTRACT: "bg-blue-50 text-blue-700 border-blue-200",
  ACTIVE: "bg-emerald-50 text-emerald-700 border-emerald-200",
  TRIAL: "bg-amber-50 text-amber-700 border-amber-200",
};
